import { render, staticRenderFns } from "./CollectionBuilder.vue?vue&type=template&id=6d4c903b&scoped=true"
import script from "./CollectionBuilder.vue?vue&type=script&lang=js"
export * from "./CollectionBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4c903b",
  null
  
)

export default component.exports